// One source of truth for navigation. The bottom bar, the header links and the
// browser tab title all read from here, so a fourth destination means editing this
// array and nothing else.

export const HomeIcon = 'M3 10.5 12 3l9 7.5M5.25 9.75V20a1 1 0 0 0 1 1h3.5v-5.5h4.5V21h3.5a1 1 0 0 0 1-1V9.75'
export const OrdersIcon = 'M6 3h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM14 3v5h5M8.5 13h7M8.5 17h4.5'
export const SettingsIcon = 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5a7.5 7.5 0 0 1 15 0'

export const NAV_ITEMS = [
  { key: 'home', label: 'Home', title: 'Home', path: '/home', icon: HomeIcon },
  { key: 'orders', label: 'Orders', title: 'My Orders', path: '/orders', icon: OrdersIcon },
  { key: 'settings', label: 'Account', title: 'Account', path: '/settings', icon: SettingsIcon },
]

// Routes that are not nav destinations still deserve a sensible tab title.
export const ROUTE_TITLES = [
  { match: /^\/$/, title: 'Sign in' },
  { match: /^\/partners\/[^/]+$/, title: 'Partner' },
  { match: /^\/order\/[^/]+\/success$/, title: 'Order placed' },
  { match: /^\/order\/[^/]+$/, title: 'Place an order' },
  { match: /^\/orders\/[^/]+$/, title: 'Order details' },
]

export const titleFor = (pathname) => {
  const nav = NAV_ITEMS.find((item) => item.path === pathname)
  if (nav) return nav.title

  return ROUTE_TITLES.find((entry) => entry.match.test(pathname))?.title ?? 'Not found'
}
